import $ from 'jquery';

class Footnotes {
    constructor() {
        this.$accordionButton = $('.js-footnotes-button');
        this.$accordionContent = $('.js-footnotes-content');
        this.$allFootnoteLinks = this.getAllLinks();
        this.$allFootnotes = $('.js-footnote');

        if (this.$allFootnoteLinks.length > 0) {
            this.formatLinks(this.$allFootnoteLinks);
        }

        this.$accordionButton.on('click', $.proxy(this.toggleContent, this));

        this.$allFootnotes.on('click', () => {
            this.$accordionButton.addClass('is-open').attr('aria-expanded', 'true');
            this.$accordionContent.slideDown();
        });

        // Select and add click event to dynamically created footnotes
        $('body').on('click', '.footnote > a', () => {
            const $button = $('.js-footnotes-button');
            const $content = $('.js-footnotes-content');

            $button.addClass('is-open').attr('aria-expanded', 'true');
            $content.show();
        });
    }

    getAllLinks() {
        const $ftnLinks = $('a[href*="#_ftn"]');
        const $ednLinks = $('a[href*="#_edn"]');

        return $.merge($ftnLinks, $ednLinks);
    }

    formatLinks($allFootnoteLinks) {
        // Change footnotes in body
        $('body').addClass('has-dynamic-footnotes');
        const $footnoteReferences = this.getRefLinks($allFootnoteLinks);
        const $footnotesInContent = $allFootnoteLinks.not($footnoteReferences);

        this.cleanUpContentFootnotes($footnotesInContent);

        // Change footnotes in footer
        $footnoteReferences.parent().addClass('c-footnotes__name js-footnote-content');
        $('.c-footnotes__name').wrap('<li class="c-footnotes__list-item js-auto-footnotes"></li>');

        this.checkPTags();

        $('.js-auto-footnotes').wrapAll('<ol class="c-footnotes__list js-footnotes-content"></ol>');

        this.cleanUpFootnoteReferences($footnoteReferences);

        // Change h2 tag to h3 tag and wrap with a button
        $('.c-footnotes__list').prev().addClass('js-change-heading');
        this.formatTag('js-change-heading', 'c-footnotes__heading', 'h3');

        const $heading = $('.c-footnotes__heading');
        const $button = $('<button class="c-footnote-button js-footnotes-button" aria-expanded="false"></button>');
        const $icon = $('<span class="c-footnote-icon"></span>');

        $heading.wrap($button);
        $heading.after($icon);

        // Adding click event listener to the button
        $('.js-footnotes-button').on('click', () => {
            $('.js-footnotes-button').toggleClass('is-open');
            $('.js-footnotes-button').next('.js-footnotes-content').slideToggle();

            if ( $('.js-footnotes-button').hasClass('is-open')) {
                $('.js-footnotes-button').attr('aria-expanded', 'true');
            } else {
                $('.js-footnotes-button').attr('aria-expanded', 'false');
            }
        });
    }

    getRefLinks($allFootnoteLinks) {
        const $ftnRefLinks = $allFootnoteLinks.filter('a[href*="#_ftnref"]');
        const $ednRefLinks = $allFootnoteLinks.filter('a[href*="#_ednref"]');

        return $.merge($ftnRefLinks, $ednRefLinks);
    }

    cleanUpContentFootnotes($footnotesInContent) {
        for (let i = 0, l = $footnotesInContent.length; i < l; i++) {
            const footnote = $footnotesInContent[i];
            const withBracket = footnote.textContent;

            footnote.innerHTML = withBracket.replace(/[[\]']+/g, '');
            $(footnote).wrap('<sup class="footnote"></sup>');
        }
    }

    cleanUpFootnoteReferences($footnoteReferences) {
        $footnoteReferences.each((index, element) => {
            const $listItem = $(element).closest('li');
            const $listIcon = $listItem.first('p').find('a:first');

            $listIcon.addClass('c-footnotes__link');
            $listIcon.text('');
            $listItem.find('p').last().append($listIcon);
        });
    }

    checkPTags() {
        const $liTags = $('.js-auto-footnotes');

        $liTags.each(function () {
            $(this).append($(this).nextUntil('li'));
        });
    }

    formatTag(currentClass, newClass, newTag) {
        const tag = document.querySelector(`.${currentClass}`);
        tag.outerHTML = `<${newTag} class = "${newClass}">${tag.innerHTML}</${newTag}>`;
    }

    toggleContent(e) {
        const $elem = $(e.currentTarget);
        $elem.toggleClass('is-open');
        const $content = $elem.next().find('.js-footnotes-content');

        $content.slideToggle('slow');

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }
    }
}

export default Footnotes;
